import logo from "./pics/fadil-novalic.jpg";
import "./App.css";

function App() {
  console.log("Fadile! Lopove!");
  return (
    <div className="App">
      <div>
        <img src={logo} className="fadil" alt="logo" />
      </div>
      <a href="https://en.wikipedia.org/wiki/Fadil_Novali%C4%87">O Fadilu</a>
      <div>
        <ul style={{ "list-style-type": "none" }} className="fadil-lista">
          <li className="fadil-vijest">
            <b>10.06.2021 </b>-{" "}
            <a href="https://www.klix.ba/vijesti/bih/novalic-potpisali-smo-ugovor-za-nabavku-500-000-doza-vakcina-sinopharm/210610049">
              Novalić: Potpisali smo ugovor za nabavku 500.000 doza vakcina
              Sinopharm
            </a>
          </li>
          <li className="fadil-vijest">
            <b>04.06.2021</b> -{" "}
            <a href="https://www.klix.ba/vijesti/bih/novalic-za-15-dana-potpisujemo-ugovor-s-pfizerom-za-milion-vakcina/210604140">
              Novalić: Za 15 dana potpisujemo ugovor s Pfizerom za milion
              vakcina
            </a>
          </li>
          <li className="fadil-vijest">
            <b>31.05.2021</b> -{" "}
            <a href="https://www.klix.ba/vijesti/bih/novalic-ugovor-o-nabavci-500-000-doza-sinopharm-vakcine-je-u-fazi-potpisivanja/210531127">
              Novalić: Ugovor o nabavci 500.000 doza Sinopharm vakcine je u fazi
              potpisivanja
            </a>
          </li>
          <li className="fadil-vijest">
            <b>26.05.2021</b> -{" "}
            <a href="https://www.klix.ba/vijesti/bih/vlada-fbih-najavila-potpisivanje-ugovora-za-nabavku-milion-i-po-vakcina/210526093">
              Vlada FBiH najavila potpisivanje ugovora za nabavku milion i po
              vakcina
            </a>
          </li>
          <li className="fadil-vijest">
            <b>20.05.2021</b> -{" "}
            <a href="https://www.klix.ba/vijesti/bih/novalic-najavio-da-ce-sljedece-sedmice-u-parlament-poslati-tri-ugovora-za-nabavku-vakcina/210520151">
              Novalić najavio da će sljedeće sedmice u Parlament poslati tri
              ugovora za nabavku vakcina
            </a>
          </li>
          <li className="fadil-vijest">
            <b>29.04.2021</b> -{" "}
            <a href="https://www.klix.ba/vijesti/bih/novalic-nabavljamo-1-5-miliona-vakcina-kroz-tri-kanala-uskoro-ugovori/210429098">
              Novalić: Nabavljamo 1,5 miliona vakcina kroz tri kanala, uskoro
              ugovori
            </a>
          </li>
          <li className="fadil-vijest">
            <b>06.04.2021</b> -{" "}
            <a href="https://www.klix.ba/vijesti/bih/federacija-nabavlja-500-000-doza-kineske-vakcine-sinopharm-pregovori-pocinju-naredne-sedmice/210406123">
              Federacija nabavlja 500.000 doza kineske vakcine Sinopharm,
              pregovori počinju naredne sedmice
            </a>
          </li>
          <li className="fadil-vijest">
            <b>29.03.2021</b> -{" "}
            <a href="https://www.klix.ba/vijesti/bih/novalic-potpisao-pismo-namjere-za-kupovinu-500-hiljada-doza-kineskog-sinopharma/210329110">
              Novalić potpisao pismo namjere za kupovinu 500 hiljada doza
              kineskog Sinopharma
            </a>
          </li>
          <li className="fadil-vijest">
            <b>15.03.2021</b> -{" "}
            <a href="https://www.klix.ba/vijesti/novalic-u-jos-cetiri-kompanije-uputio-pisma-namjere-u-opticaju-tri-vrste-vakcina/210315157">
              Novalić u još četiri kompanije uputio pisma namjere, u opticaju
              tri vrste vakcina
            </a>
          </li>
          <li className="fadil-vijest">
            <b>11.03.2021</b> -{" "}
            <a href="https://www.akta.ba/vijesti/novalic-najavio-kupovinu-ruskih-vakcina-po-cijeni-od-17-eura/132197">
              Novalić najavio kupovinu ruskih vakcina po cijeni od 17 eura
            </a>
          </li>
          <li className="fadil-vijest">
            <b>18.12.2020</b> -{" "}
            <a href="https://www.klix.ba/vijesti/bih/novalic-za-klix-ba-u-ponedjeljak-cemo-uplatiti-novac-za-nabavku-vakcina/201218070">
              Novalić za Klix.ba: U ponedjeljak ćemo uplatiti novac za nabavku
              vakcina
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default App;
